<template>
<div id="watchcard--body">
  <vignette :icon="'fa-tv'" :color="'#b70626'"  v-if="!isMobile"></vignette>
    <div id="watchcard--synopsis" class="flexwrap"  :class="!isMobile?'navTheme':''">
      <h2>Synopsis</h2>
      <span>
      {{ synopsis }}
      </span>
    </div>
  <div class="flexwrap centercenter paddingRound" v-if="!isMobile" style="grid-row: 3/4;grid-column: 1/2; font-style: italic; opacity: 0.6; text-align: center">
    <span>~ Astuce ~</span> <span  style="font-size: 0.9em">Regarde l'épisode en vitesse x0.75 pour plus facilement comprendre les dialogues.</span>
  </div>
  <div id="watchcard--vocabulary" class="flexwrap" :class="!isMobile?'navTheme':''">
    <h2>Cheat Sheet</h2>

    <loading-logo id="loadingWords"
                  v-if="wordsList.length===0"></loading-logo>
    <transition name="fade" mode="out-in" v-else appear>
      <div id="watchcard--vocabulary--content" class="flexwrap">
        <learnt-word v-for="(word, index) in wordsList" :key="index" :lemma="word"> </learnt-word>
      </div>
    </transition>

  </div>
  <standard-button v-if="!watchClicked"
      id="watchcard--start" class="flexwrap centercenter" :color-class="'red'" :href="'https://www.netflix.com/watch/' + netflixId" @click="start_watch">
    <div id="watchCardNetflix" class="flexwrap centercenter">
      <img id="watchCardNetflixImg" src="../assets/netflix.png" alt=""/>
    </div>
<div>Lancer l'épisode</div>
  </standard-button>

  <standard-button v-else
       id="watchcard--start" class="flexwrap centercenter" :color-class="'red'"
                   @click="returnMenu">
    <div class="flexwrap centercenter">Terminer</div>
  </standard-button>

</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {API_URL} from "@/App";
import axios from "axios";
import LoadingLogo from "@/components/loadingLogo";

export default {
  name: "watchCard",
  components: {
    LoadingLogo,
    //Infobulle,
    Vignette: () => import(/* webpackPrefetch: true */ '@/components/vignette.vue'),
    StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
    LearntWord: () => import(/* webpackPrefetch: true */ '@/components/learntWord.vue')
  },
  props: {
    synopsis: String,
    wordsList: Array,
    wordsLoaded: Boolean,
    netflixId: Number,
    title: String
  },

  created() {

    /*if(!this.currentEpisodeData.user_episode.watch_check){
      // this.profile.datas.points += 2* Math.round(this.currentEpisodeData.dialogue_length +1)

    }*/
    this.currentEpisodeData.user_episode.watch_check = true
    if(!this.currentSeason.questions){
      this.currentEpisodeData.user_episode.uq_check = true
    }

    if (this.currentEpisodeData.user_episode.watch_check &&
        this.currentEpisodeData.user_episode.learn_check && this.currentEpisodeData.user_episode.uq_check) {
      this.currentEpisodeData.user_episode.check = 2
    }

    let payload = {
      "watch_check" : this.currentEpisodeData.user_episode.watch_check,
      "uq_check" : this.currentEpisodeData.user_episode.uq_check
    }

    const url = `${API_URL}/api/auth0userepisode/` + this.currentEpisodeData.id  + '/'
    this.$webAuth.checkSession({}, (error, authResult) => {
      if(!error) {
        axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
            .then(response => {
              this.set_dataReload()
            })
      }
      else {
        console.log(error)
      }
    })
  },

  beforeDestroy() {
    this.set_gameWordsList([])
    this.set_gameWordsListLoaded(false)
  },


  computed: {
    ...mapGetters('global', [
        'isMobile',
      'states',
      'profile'
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
      'currentShow',
      'currentSeason',
    ]),
  },

  methods: {
    ...mapActions('global', [
        'set_appStep',
      'set_carousselNavTo',
      'set_carousselNavTransition',
        'set_dataReload'
    ]),
    ...mapActions('game', [
        'set_gameWordsList',
      'set_gameWordsListLoaded'
    ]),

    start_watch: function () {

      window.setTimeout(() => {this.watchClicked = true}, 1000)

    },

    returnMenu: function () {
      this.set_carousselNavTo(1)
      this.set_appStep(this.states.MENU)
      window.setTimeout( () =>{this.set_carousselNavTransition(true)
      }, 50);
    }

  },

  data() {
    return {
      watchClicked: false
    }
  }


}
</script>

<style scoped>
  #watchcard--body{
    flex-grow: 1;
    display: grid;
    grid-template-rows: auto auto 1fr 1fr;
    grid-template-columns: 3fr 5fr;
    padding: 1vw;
    grid-gap: 1vw;
    /*height: calc(100% - 2vw);*/
    align-items: center;
  }
  #watchcard--title{
    grid-column: 1/3;
    grid-row: 1/2;
    font-size: 2.2em;
    text-align: center;
    font-weight: bold;
  }
  #watchcard--synopsis{
    grid-column: 1/2;
    grid-row: 2/3;
    border-radius: 1vw;
    font-size: 1.3em;
    padding: 0.5vw;
  }
  #watchcard--vocabulary{
    grid-column: 2/3;
    grid-row: 1/5;
    height: calc(100% - 1vw);
    border-radius: 1vw;
    padding: 0.5vw;
  }
  #watchcard--vocabulary--content{
    padding-top: 0.5vw;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
  }
  #watchcard--start{
    grid-column: 1/2;
    grid-row: 4/5;
  }
  #watchCardNetflix{
    height: 1.5vw;
    width: 1.5vw;
    margin-right: 0.5vw;
    background-color: black;
    border-radius: 1.5vw;
  }
  #watchCardNetflixImg{
    height: 0.9vw
  }

  @media screen and (max-device-width: 767px) {

    #watchcard--body{
      display: grid;
      grid-template-rows: auto 1fr auto;
      grid-template-columns: 1fr;
      grid-gap: 1vw;
      height: calc(100% - 10vw);
      max-height: calc(90vh - 16vw);
      align-items: center;
      padding: 5vw;
    }
    #watchcard--synopsis{
      grid-column: 1/2;
      grid-row: 1/2;
      height: 100%;
      font-size: 1.2em;
    }

    #watchcard--vocabulary{
      grid-column: 1/2;
      grid-row: 2/3;
      overflow: auto;
      padding-top: 1vw;
    }
    #watchcard--vocabulary--content{
      min-height: 40vw;
      padding-top: 2vw;
    }
    #watchcard--start{
      grid-column: 1/2;
      grid-row: 3/4;
    }
    #watchCardNetflix{
      height: 6vw;
      width: 6vw;
      margin-right: 2vw;
      border-radius: 6vw;
    }
    #watchCardNetflixImg{
      height: 3.5vw
    }

  }

</style>